import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WorkshopJobcardContext {
  serviceTypes$ = new BehaviorSubject<any[]>([]);
  technicians$ = new BehaviorSubject<any[]>([]);
  systemUsers$ = new BehaviorSubject<any[]>([]);
  thirdParties$ = new BehaviorSubject<any[]>([]);

  setServiceTypes(serviceTypes: any[]) {
    this.serviceTypes$.next(serviceTypes);
  }

  setTechnicians(technicians: any[]) {
    this.technicians$.next(technicians);
  }

  setSystemUsers(systemUsers: any[]) {
    this.systemUsers$.next(systemUsers);
  }

  setThirdParties(thirdParties: any[]) {
    this.thirdParties$.next(thirdParties);
  }

}